import React, {useState} from 'react';

import styles from './CheckboxSchemaTemplate.module.css'
import {Checkbox} from "../Checkbox.tsx";
import {Icon} from "../../../../General/Icon/Icon.tsx";
import {cn} from "../../../../../utils/cn.ts";
import {filteredList} from "../../../../../utils/formatters/index.ts";

interface Props {
    label: string
    values: {id: number, name: string}[]
    setIds: (ids: number[]) => void
}

export const CheckboxSchemaTemplate: React.FC<Props> = ({values, label,setIds }) => {
    const [checkedValues, setCheckedValues] = useState<number[]>([])
    const [valuesLength, setValuesLength] = useState(8);
    const [searchString, setSearchString] = useState('');

    const toggleChange = (value: number) => {
        let newIds = [];
        if (checkedValues.includes(value)) {
            checkedValues.map(checkedValue => {
                if(checkedValue !== value) newIds.push(checkedValue);
            })
        }
        else {
            checkedValues.map(checkedValue => {
                newIds.push(checkedValue);
            })
            newIds.push(value);
        }
        setIds(newIds);
        setCheckedValues(newIds);
    }

    return (
        <div className={styles.checkbox}>
            {label && <h4>{label}</h4>}
            <div className={styles.select}>
                <Icon name='search' width={18} height={18} color='#ccc' />
                <input
                    type='text'
                    placeholder="Поиск"
                    className={cn(styles.searchInput)}
                    value={searchString}
                    onChange={event => setSearchString(event.target.value)}
                />
            </div>
            <div className={styles.checkboxList}>
                {filteredList(values, searchString).map((schema, key) => {
                    if(key > valuesLength && searchString === '') return null;
                    return (
                        <div className={styles.checkBoxesItem}>
                            <Checkbox
                                key={schema.id}
                                checked={checkedValues.includes(schema.id)}
                                label={schema.name.toUpperCase()}
                                onClick={() => toggleChange(schema.id)}/>
                        </div>
                    )}
                )}
                {
                    valuesLength < values.length && values.length && searchString === ''
                        ? <div style={{textDecoration: 'underline', cursor: 'pointer',}}
                               onClick={() => setValuesLength(values.length)}>Показать
                            ещё {values.length - valuesLength}</div>
                        : <div style={{textDecoration: 'underline', cursor: 'pointer',}}
                               onClick={() => setValuesLength(8)}>Свернуть</div>
                }
            </div>
        </div>
    );
};